<script>
import RetailerEdit from '../retailer/edit/retailer-edit'

export default {
  name: 'RetailerNew',
  page: {
    title: 'New Retailer',
  },
  components: { RetailerEdit },
  data() {
    return {
      backRoute: { name: 'retailers' },
    }
  },
  methods: {
    onCancel() {
      this.$router.push(this.backRoute)
    },
  },
}
</script>

<template>
  <main-layout
    title="New Retailer"
    :back="backRoute"
  >
    <retailer-edit @cancel="onCancel" />
  </main-layout>
</template>
